import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=bfba2506&scoped=true"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"
import style0 from "./CompanySearch.vue?vue&type=style&index=0&id=bfba2506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfba2506",
  null
  
)

export default component.exports